import React, {Component} from 'react';



class BtnsEstado extends Component {

    render(){

        const {estado, cambia} = this.props; 
        return (
            <span>
                {estado==='borrador' ? 
                (
                    <span>
                        <button className="btn-estado" onClick={cambia}>Publicar</button>
                        <span className="span-estado">Borrador</span>
                    </span>
                ) 
                : 

                (
                    <span>
                        <span className="span-estado">Publicada</span>
                        <button className="btn-estado" onClick={cambia}>Borrador</button>
                    </span>
                )
            
            }
                
            </span>
        )
    }
};

export default BtnsEstado;